import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import './Logout.css';

/**
 * Logout page component that handles user logout when the route is accessed
 */
function Logout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        console.log('Logout route accessed, performing logout...');
        await logout();
        console.log('Logout completed successfully');
        // Navigation will be handled by AuthContext
      } catch (error) {
        console.error('Logout failed:', error);
        // Even if logout fails, redirect to login page
        navigate('/login', { replace: true });
      }
    };

    performLogout();
  }, [logout, navigate]);

  return (
    <div className="logout-container">
      <LoadingSpinner size="large" overlay={true} />
      <div className="logout-message">
        <h2>Logging you out...</h2>
        <p>Please wait while we securely log you out of the application.</p>
      </div>
    </div>
  );
}

export default Logout;
